module.exports = __webpack_public_path__ + "img/edit-final.98bc32ce.png";